// component compatible with antd Form.Item
import React from "react"
import ActivityListItem from "../ActivityListItem/ActivityListItem"
import type { StudyActivity, PayloadAttach } from "../LinkActivitiesModal"

type AttachActivityItemProps = {
  value?: PayloadAttach
  onChange?: (value: PayloadAttach) => void
  onRemove: () => void
  studyActivities: StudyActivity[]
  disabled?: boolean
}

const AttachActivityItem = ({ value, onChange, onRemove, studyActivities, disabled }: AttachActivityItemProps) => {
  const getStudyActivity = (id: number): StudyActivity | undefined =>
    studyActivities.find((activity: StudyActivity) => activity.id === id)

  const getAttachActivityName = (id: number): string | null => {
    // name to be added
    const addedName = value?.name
    if (addedName !== undefined) return addedName
    // or name saved, not same as type title
    const savedActivity = studyActivities.find((studyActivity: StudyActivity) => studyActivity.id === id)
    if (savedActivity && savedActivity.project_type_title !== savedActivity.project_title) {
      return savedActivity.project_title
    }
    // or null
    return null
  }

  const handleChangeName = (name: string | null) => {
    if (value?.project_id) {
      if (onChange) onChange({ project_id: value.project_id, name: name || null })
    }
  }

  if (!value) return null

  return (
    <ActivityListItem
      key={getStudyActivity(value.project_id)?.id}
      type="created"
      id={getStudyActivity(value.project_id)?.id ?? 0} // TODO: setting to 0 as default to avoid TS error
      title={getStudyActivity(value.project_id)?.project_type_title ?? ""}
      status={getStudyActivity(value.project_id)?.actual_completion_date ? "Completed" : "In Progress"}
      onRemove={onRemove}
      name={getAttachActivityName(value.project_id)}
      onSetName={handleChangeName}
      disabled={disabled}
    />
  )
}

export default AttachActivityItem
